module.exports = "<div class=\"btn-group\" role=\"group\" aria-label=\"...\">\n  <button type=\"button\" class=\"btn btn-default\">Left</button>\n  <button type=\"button\" class=\"btn btn-default\">Middle</button>\n  <button type=\"button\" class=\"btn btn-default\">Right</button>\n</div>"


/*****************
 ** WEBPACK FOOTER
 ** ./frontend/components/active/active.html
 ** module id = 185
 ** module chunks = 0
 **/